export interface participanteModel {
  tipo_participante: number;
  tipo_identificacion: string;
  numero_documento: string;
  primer_nombre: string;
  segundo_nombre: string;
  primer_apellido: string;
  segundo_apellido: string;
  sexo: string;
  indicativo: string;
  fecha_nacimiento: string | any;
  numero_contacto: string;
  direccion_residencia: string;
  pais_nacimiento: string;
  pais_residencia: string;
  departamento_nombre: string;
  departamento: string;
  orientacion?: string;
  identidad?: string;
  municipio_nombre: string;
  municipio: string;
  comuna_nombre: string;
  comuna: string;
  barrio_nombre: string;
  barrio: string;
  estrato: string;
  correo_electronico: string;
  telefono_celular: string;
  politicas: boolean;
  modalState: boolean;
  path_foto: string;
  etnia?:string;
  nit?: any;
  datos_empresa: { nit: string, razon_social: string, direccion_empresa: string };
  direccion_empresa?: string;
  razon_social: string;
  // departamento_residencia?: string;
  // municipio_residencia?: string;
  // comuna_residencia?: string;
}

export const participanteModelInitialValues = {
  tipo_participante: 1,
  tipo_identificacion: "",
  numero_documento: "",
  primer_nombre: "",
  segundo_nombre: "",
  primer_apellido: "",
  segundo_apellido: "",
  sexo: "",
  indicativo: "",
  fecha_nacimiento: "",
  numero_contacto: "",
  direccion_residencia: "",
  pais_nacimiento: "",
  pais_residencia: "",
  departamento_nombre: "",
  departamento: "",
  orientacion: "",
  identidad: "",
  municipio_nombre: "",
  municipio: "",
  comuna_nombre: "",
  comuna: "",
  barrio_nombre: "",
  barrio: "",
  estrato: "",
  correo_electronico: "",
  telefono_celular: "",
  etnia: "",
  path_foto: "",
  politicas: false,
  modalState: true,
  razon_social: "",
  datos_empresa: { nit: "", razon_social: "", direccion_empresa: "" }
};
